import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class RespiratoryRateMeasuredJournalEvent extends JournalEvent {
  static override type = "respiratory-rate-measured-journal-event";

  @attr("number") declare respiratoryRate: number;

  static override validations(intl: IntlService) {
    return {
      respiratoryRate: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.respiratory-rate-measured-journal-event.respiratory-rate"
          )
        }),
        validateNumber({
          gt: 1,
          lte: 200,
          description: intl.t(
            "validations.respiratory-rate-measured-journal-event.respiratory-rate"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.respiratory-rate-measured-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "respiratoryRateMeasuredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "respiratory-rate-measured-journal-event": RespiratoryRateMeasuredJournalEvent;
  }
}
